import { getWorkSheetHeight } from '../../../utils/workSheetHelper';

export default workSheet => {
  const range = workSheet['!ref'];

  const height = getWorkSheetHeight(range);

  return `A2:C${height}`;
};
